/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import {
  VehicleApiProps,
} from './types';
import vehicle from './sectionvehicle';

const vehicleTag = baseApi.enhanceEndpoints({ addTagTypes: [vehicle.tagType] });
const vehiclelApi = vehicleTag.injectEndpoints({
  endpoints: (builder) => ({
    getSectionVehicle: builder.query<VehicleApiProps, number>(vehicle.getEntity()),
  }),
  overrideExisting: false,
});

export const {
  useGetSectionVehicleQuery,
} = vehiclelApi;
